// @format
export enum Domain {
  API = 'https://bunnycdn.com/api/',
  Storage = 'https://storage.bunnycdn.com',
}
